import { NgModule } from '@angular/core';
import { SharedModule } from '@approot/shared/shared.module';
import { DirectRfqModule } from './direct-rfq/direct-rfq.module';
import { MarketsDetailModule } from './markets-detail/markets-detail.module';
import { RfqModule } from './rfq/rfq.module';
import { StrategiesViewerComponent } from './strategies-viewer/strategies-viewer.component';
import { StrategyDetailModule } from './strategy-detail/strategy-detail.module';
@NgModule({
  declarations: [StrategiesViewerComponent],
  imports: [SharedModule],
  exports: [
    MarketsDetailModule,
    RfqModule,
    StrategyDetailModule,
    StrategiesViewerComponent,
    DirectRfqModule
  ]
})
export class WidgetsModule {}
